import React from 'react';
import style from '../BonusesTable/BonusesTable.module.css';
import s from './TableChecks.module.css';
import arrow2 from '../../../../assets/img/icons/Arrow 2.svg';
import {BonusType} from '../../../../types/TypesUserOrders';
import EasyGreenCheckBox from '../../../../Components/CustomCheckbox/EasyGreenCheckBox';

type Props = {
	bonus: BonusType;
	checked: boolean;
	handleChange: (id: string) => void;
	handleClickAction: (id: number) => void;
};
const TableChecksRowElement: React.FC<Props> = ({
	bonus,
	checked,
	handleChange,
	handleClickAction,
}) => {
	const {id, create_date, name, money, status, points} = bonus;
	const statusMap: Record<string, string> = {
		pending: 'Очікує списання',
		paid: 'Списано',
	};
	const getStatusText = (status: string) => statusMap[status] || status;

	return (
		<div className={`${style.tableGridRow} ${s.checksTable}`}>
			<div className={`${style.tableGridColumn} ${s.checkboxColumn}`}>
				<EasyGreenCheckBox
					label={''}
					checked={checked}
					handleChange={handleChange}
					id={id.toString()}
				/>
				<div>{create_date}</div>
			</div>
			<div className={style.tableGridColumn}>{name}</div>
			<div className={style.tableGridColumn} title={`${money} грн`}>
				{points}
			</div>
			<div className={style.tableGridColumn}>{getStatusText(status)}</div>
			<div className={style.tableGridColumn}>
				<button onClick={() => handleClickAction(id)}>
					<img src={arrow2} alt="arrow" />
				</button>
			</div>
		</div>
	);
};

export default TableChecksRowElement;
